import axios from 'axios'
import { sha256 } from 'js-sha256'
import { AUTH, TOKEN } from '../utils/constant'
import { MD5 } from '../utils/md5'
import store from '../store'

const axiosInstance = axios.create()
axiosInstance.defaults.timeout = 10000
axiosInstance.defaults.retry = 3
axiosInstance.defaults.retryDelay = 1000
axiosInstance.defaults.baseURL = process.env.VUE_APP_BASE_API

// Add a request interceptor
axiosInstance.interceptors.request.use(
  function(config) {
    // const querys = store.state.querys
    // Do something before request is sent
    // 设置头部信息
    // const minis = new Date().getTime()
    // const message = sha256(minis + AUTH)
    config.headers.systemCode = 'qianbao'
    config.headers.channelCode = '111'
    config.headers.upstreamCode = 'xcx'
    config.headers.appid = 'h5App'
    // config.headers.shtoken = localStorage.getItem('shtoken') || ''
    config.headers.shtoken = `JSESSIONID=${localStorage.getItem('shtoken')};` //小程序传来的jsessionid
    // config.headers.message = message.toUpperCase()
    config.headers['Content-Type'] =
      'application/x-www-form-urlencoded;charset=UTF-8'

    // 设置请求参数信息
    // const params = config.data || {}
    // params.sign = MD5(params)

    // config.data = params
    config.transformRequest = [
      function(data) {
        let ret = ''
        for (let it in data) {
          if (data.hasOwnProperty(it)) {
            ret +=
              encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
        }
        return ret
      }
    ]
    return config
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response.status === 200) {
      return response.data
    }
    return response
  },
  function(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error)
  }
)

export default axiosInstance
